import React, { Component } from 'react';
import { Link } from "react-router-dom";

import config from './../config';

class SearchResultsLanguageOverview extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/es/agg/languages/';

		this.state = {
			listData: [],
			selectedItem: ''
		};
	}

	componentDidMount() {
		if (this.props.searchParams.searchString || this.props.searchParams.ordabok) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (
			prevProps.searchParams.searchString != this.props.searchParams.searchString ||
			prevProps.searchParams.ordabok != this.props.searchParams.ordabok
		) {
			this.fetchData();
		}

		if (prevProps.searchParams.order != this.state.selectedItem) {
			this.setState({
				selectedItem: this.props.searchParams.order
			});
		}
	}

	sortLanguages(data) {
		let languages = [
			'IS',
			'EN',
			'NN',
			'DE',
			'LA',
			'NOB',
			'DK',
			'SM',
			'GL',
			'FO',
			'RU',
			'SANSKRIT',
			'PL',
			'GRISKA',
			'EI',
			'ES',
			'SV',
			'PT',
			'FR',
			'SF',
			'JP',
			'IT',
			'NL'
		];

		let result = [];

		languages.forEach(function(key) {
			var found = false;
			data = data.filter(function(item) {
				if (!found && item.fklanguage == key) {
					result.push(item);
					found = true;
					return false;
				} else {
					return true;
				}
			})
		});

		return result;
	}

	fetchData() {
		this.setState({
			searchString: this.props.searchParams.searchString,
			selectedItem: ''
		});

		let urlParams = [];
		if (this.props.searchParams.searchString) {
			urlParams.push('ord='+this.props.searchParams.searchString);
		}
		if (this.props.searchParams.ordabok) {
			urlParams.push('ordabok='+this.props.searchParams.ordabok);
		}

		fetch(this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					listData: this.sortLanguages(json.results),
					resultsCount: json.results.reduce(function(s, f) {
						return s+f.count;
					}, 0),
					prevUrl: json.previous || null,
					nextUrl: json.next || null
				})
			}.bind(this));
	}

	render() {
		let forceTabs = false;
		let tabLimit = 10;

		return (
			<React.Fragment>
				{
					this.state.listData.length > 0 &&
					<React.Fragment>

						<div className={'nav pr-5'+(this.state.listData.length > tabLimit && !forceTabs ? ' nav-pills' : ' nav-tabs')} style={
							{
								position: 'relative',
								marginBottom: this.state.listData.length > tabLimit && !forceTabs ? 10 : -1
							}
						}>
							<div className={'navbar-text text-secondary mr-4'+(this.state.listData.length > tabLimit ? ' ml-sm-3' : ' ml-sm-4')}>Raða eftir:</div>
							{
								this.state.listData.map(function(item, index) {
									return <span key={index} className="nav-item">
										<Link to={'/leit/'+(this.props.searchParams.searchString ? this.props.searchParams.searchString : '')+(this.props.searchParams.ordabok ? '/ordabok/'+this.props.searchParams.ordabok : '')+'/order/'+item.fklanguage} 
											onClick={function() {
												this.setState({
													selectedItem: item.fklanguage
												})
											}.bind(this)}
											className={'nav-link'+(this.state.selectedItem == item.fklanguage || (!this.state.selectedItem && item.fklanguage == 'IS') ? ' active' : '')}>
											{window.ordabankiData.lang && window.ordabankiData.lang[item.fklanguage] ? window.ordabankiData.lang[item.fklanguage] : item.fklanguage} {this.props.searchParams.searchString && item.count < 500 ? '('+item.count+')' : ''}
										</Link>
									</span>;
								}.bind(this))
							}

						</div>

					</React.Fragment>
				}
			</React.Fragment>
		);
	}
}

export default SearchResultsLanguageOverview;



// WEBPACK FOOTER //
// ./src/components/SearchResultsLanguageOverview.js